import { Link } from 'react-router-dom';
import PageHeader from './PageHeader';
import SnailOnly from './SnailOnly';
import { species, intro } from './foragingData';
import './ForagingGuide.css';

export default function ForagingGuide() {
  return (
    <div className="fg-page">
      <PageHeader />
      <div
        className="fg-hero"
        style={{ backgroundImage: 'linear-gradient(to bottom, rgba(42,43,34,0.45) 0%, rgba(42,43,34,0.65) 100%), url(/backgrounds/urban-foraging.jpg)' }}
      >
        <SnailOnly className="snail-watermark" />
        <div className="fg-hero-overlay">
          <Link to="/" className="fg-back">&larr; Back to home</Link>
          <div className="fg-hero-text">
            <p className="fg-eyebrow">Field Guide</p>
            <h1 className="fg-hero-title">{intro.heading}</h1>
            <p className="fg-hero-region">{intro.region}</p>
          </div>
        </div>
      </div>

      <div className="fg-body">
        <div className="fg-inner">

          <p className="fg-text">{intro.introText}</p>

          <h2 className="fg-section-title">Golden Rules of Ethical Foraging</h2>
          {intro.goldenRulesIntro.map((p, i) => <p className="fg-text" key={i}>{p}</p>)}
          <ol className="fg-rules">
            {intro.goldenRules.map((rule, i) => <li key={i}>{rule}</li>)}
          </ol>
          <p className="fg-text">{intro.goldenRulesOutro}</p>

          <hr className="fg-divider" />

          <h2 className="fg-section-title" id="species">Species Directory</h2>
          <p className="fg-text">
            Identification notes, lookalikes, foraging guidance, and a recipes.
          </p>

          <div className="fg-grid">
            {species.map(s => (
              <Link to={`/foraging-guide/${s.slug}`} key={s.slug} className="fg-card">
                {s.images.length > 0 ? (
                  <img className="fg-card-img" src={`/foraging/${s.images[0]}`} alt={s.name} />
                ) : (
                  <div className="fg-card-img fg-card-img--placeholder" aria-hidden="true">🌿</div>
                )}
                <div className="fg-card-body">
                  <h3>{s.name}</h3>
                  <p className="fg-card-scientific">{s.scientific}</p>
                </div>
              </Link>
            ))}
          </div>

          <hr className="fg-divider" />

          <h2 className="fg-section-title">Safety First</h2>
          <p className="fg-text">{intro.safety}</p>

          <h2 className="fg-section-title">Toxin Absorption in Wild Greens</h2>
          <p className="fg-text">{intro.toxinNotes.intro}</p>
          <div className="fg-toxin-list">
            {intro.toxinNotes.plants.map(p => (
              <div className="fg-toxin-item" key={p.name}>
                <strong>{p.name}</strong>
                <p>{p.note}</p>
              </div>
            ))}
          </div>
          <ul className="fg-rules fg-rules--unmarked">
            {intro.toxinNotes.principles.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
          <p className="fg-text">{intro.toxinNotes.specialPopulations}</p>

          <h2 className="fg-section-title" id="iodine-note">A Note on Iodine in Seaweeds</h2>
          <p className="fg-text">{intro.iodineNote.intro}</p>
          <p className="fg-text">{intro.iodineNote.rdi}</p>
          <div className="fg-iodine-table">
            {intro.iodineNote.levels.map(l => (
              <div className="fg-iodine-row" key={l.name}>
                <span className="fg-iodine-name">{l.name}</span>
                <span className="fg-iodine-level">{l.level}</span>
              </div>
            ))}
          </div>
          <p className="fg-text">{intro.iodineNote.blanching}</p>
          <p className="fg-text">{intro.iodineNote.caution}</p>

          <p className="fg-disclaimer">{intro.disclaimer}</p>

        </div>
      </div>
    </div>
  );
}
